<template>
    <div class="about-sf">
        <img class="banner" src="@/assets/images/about-sf/banner.jpg" alt="关于顺丰banner图片" />
        <nav-component :navs="navs" :active-index="navIndex" @on-switch="switchNav"></nav-component>
        <router-view :key="key" />
        <to-top></to-top>
    </div>
</template>

<script>
import { navs } from './config'
import navComponent from '@/components/navs'
import toTop from '@/components/to-top'
export default {
    name: 'AboutSf',
    components: {
        navComponent,
        toTop
    },
    data() {
        return {
            navs,
            navIndex: 0
        }
    },
    computed: {
        key() {
            return this.$route.fullPath
        }
    },
    created() {
        this.navIndex = this.navs.findIndex(item => this.key.indexOf(item.path) > -1)
    },
    methods: {
        switchNav(data) {
            if (this.key.indexOf(data.item.path) > 0) {
                return
            }
            this.$router.push({
                path: data.item.path
            })
            this.navIndex = this.navs.findIndex(item => this.key.indexOf(item.path) > -1)
        }
    }
}
</script>

<style lang="scss" scoped>
.about-sf {
    .banner {
        width: 100%;
        display: block;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/about-sf/index.vue